// --------------------------------------------------------
// src/models/theme.model.js
//
// Create and manage a Theme Model object
//
// --------------------------------------------------------
"use strict";

const ThemeModel = Backbone.Model.extend({
	// An empty book collection that will be filled when this Model is created
	bookCollection: [],

	// The default values for this Model
	defaults: {
		id		  : null,
		name 	  : null,
		fr_name : null
	}

});
